import { z } from 'zod';

import { PropertyType } from '../types/property.types.js';

export const createPropertyInput = z.object({
  name: z
    .string()
    .min(1, 'Property name must be at least 1 Character')
    .max(24, 'Name cannot be longer than 24 characters')
    .trim(),
  type: z.enum([
    PropertyType.SmallText,
    PropertyType.LongText,
    PropertyType.SingleSelect,
    PropertyType.MultiSelect,
    PropertyType.Number,
  ]),
  projectId: z.string().length(24),
  options: z.array(z.string().min(1).trim()).optional(),
});

export type CreatePropertyInput = z.infer<typeof createPropertyInput>;
